import { AddressDetailModel } from 'app/shared/models/address/address.model';
import { CacheKeys } from 'app/shared/models/energy/cache-keys.model';
import { Region } from 'app/shared/models/energy/region.model';
import { configService } from 'app/shared/services/config/config.service';

class AddressService {
  public convertAddressToString(address: AddressDetailModel): string {
    return `${address.floor ? address.floor : ''} ${address.unitNumber ? address.unitNumber : ''} ${address.streetNumber} ${
      address.streetName
    } ${address.streetType}${address.streetTypeSuffix ? ` ${address.streetTypeSuffix}` : ''}, ${address.suburb} ${address.state} ${
      address.postcode
    }`.trim();
  }

  public getRegion(): Region {
    const regionCache = localStorage.getItem(CacheKeys.region);
    if (regionCache) {
      return regionCache as Region;
    }
    return Region.VIC;
  }

  public getDefaultPostcode(): string {
    const region = this.getRegion();
    if (region) {
      switch (region.toUpperCase()) {
        case Region.VIC:
          return '3000';
        case Region.QLD:
          return '4000';
        case Region.SA:
          return '5000';
        case Region.WA:
          return '6000';
        default:
          return '2000';
      }
    }
    return '2000';
  }

  public getRegionByPostcode(postcode: string): Region {
    const postcodeRange = configService.getPostcodeRange();
    if (postcode && postcodeRange) {
      const postcodeNumeric = parseInt(postcode, 10);
      const filteredRange = postcodeRange.filter((pr) => pr.lowerRange <= postcodeNumeric && pr.upperRange >= postcodeNumeric);
      if (filteredRange.length > 0) {
        return filteredRange[0].region as Region;
      }
    }

    return null;
  }
}

export const addressService = new AddressService();
